import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AutoBindComponent from "../../common/AutoBindComponent";
import unsavedDataDialogHandler from "../../common/UnsavedDataDialogHandler";

import * as layoutActions from "../../../actions/layoutActions";

import InvesteringEditForm from "./InvesteringEditForm";
import InvesteringEditPageHelper from "./InvesteringEditPageHelper";
import * as types from "../../../constants/ComponentConstants";

import convertToLabelValuePair from "../../../util/convertToLabelValuePair.js";
import ConfirmModal from '../../common/ConfirmModal';
import redirector from '../../../util/redirector';

class InvesteringEditPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {
            model: {},
            validationMessages: {},
            aftrekbaar: [
                { value: true, label: 'ja' },
                { value: false, label: 'nee' }
            ]
        };

        this.pageHelper = new InvesteringEditPageHelper(this, redirector);
    }

    componentWillMount() {
        this.pageHelper.init();
    }

    handleOnSave() {
        this.pageHelper.save();
    }

    handleOnClose() {
        this.pageHelper.goToOverview();
    }

    handleOnChange(event) {
        this.pageHelper.change(event);
    }

    render() {
        if (!this.pageHelper.isReadyToRender())
            return null;

        return (
            <div>
                <ConfirmModal
                    isOpen={this.state.modalIsOpen}
                    mainText="Gelieve eerst infrastructuren toe te voegen alvorens investeringen toe te voegen"
                    confirmAction={() => this.pageHelper.goToProjectAdres()}
                    confirmText="Ga verder" />
                <InvesteringEditForm
                    model={this.state.model}
                    errors={this.state.validationMessages}
                    validationMessages={this.state.validationMessages}
                    color={types.COLOR_PINK_LIGHT}
                    onBewaarClick={this.handleOnSave}
                    onSluitClick={this.handleOnClose}
                    onChange={this.handleOnChange}
                    investeringTypes={this.props.investeringTypes}
                    hoofdCategorieen={this.props.hoofdCategorieen}
                    btwPercentages={this.props.btwPercentages}
                    aftrekbaar={this.state.aftrekbaar}
                    disabled={this.state.model.dossierIngediend}
                />
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const dossierId = ownProps.params.dossierId;

    return {
        dossierId: dossierId,
        investeringTypes: convertToLabelValuePair(state.referentie.typesInvestering),
        hoofdCategorieen: convertToLabelValuePair(state.referentie.hoofdCategorienInvestering),
        btwPercentages: convertToLabelValuePair(state.referentie.btwPercentages)
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadInvesteringEditPageLayout, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(InvesteringEditPage));